export default __webpack_public_path__ + "static/media/Strifescar Boots.541bef8a.jpg";